import Text from "../../../commons/Text";
import Title from "../../../commons/Title";
import classes from "./index.module.scss";
import btnClasses from "../../../commons/Button.module.scss";
import o1 from "../images/o1.png";
import o2 from "../images/o2.png";
import o3 from "../images/o3.png";
import o4 from "../images/o4.png";
import o1webp from "../images/o1.webp";
import o2webp from "../images/o2.webp";
import o3webp from "../images/o3.webp";
import o4webp from "../images/o4.webp";
import RequestDemo from "../../../Button/RequestDemo";

export default function Optimization() {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.content}>
            <Title
              title="Operational optimization"
              number={"03"}
              className={classes.title}
            />
            <Text
              text={[
                `Business logic optimized by the introduction of separate product layers
                `,
                `
                We reviewed user, partner, and product flows. 4 different product layers were introduced:`,
              ]}
              className={classes.text}
            />
          </div>
          <ul className={classes.list}>
            <li className={classes.item}>
              <div className={classes.item__content}>
                <h3>Admin panel</h3>
                <p>
                  The interface of the visual point of control and remote
                  database.
                </p>
              </div>
              <div className={classes.image}>
                <picture>
                  <source srcSet={o1webp} type="image/webp" />
                  <source srcSet={o1} type="image/png" />
                  <img src={o1} alt="Challenge" width={540} />
                </picture>
              </div>
            </li>
            <li className={classes.item}>
              <div className={classes.item__content}>
                <h3>Partner page</h3>
                <p>
                  Partner’s personal page for managing orders, product prices,
                  and tax fees.
                </p>
              </div>
              <div className={classes.image}>
                <picture>
                  <source srcSet={o2webp} type="image/webp" />
                  <source srcSet={o2} type="image/png" />
                  <img src={o2} alt="Challenge" width={540} />
                </picture>
              </div>
            </li>

            <li className={classes.item}>
              <div className={classes.item__content}>
                <h3>Integration layer</h3>
                <p>
                  Additional logic by partner request for exporting/importing
                  data related to orders from/to Parter’s origin database.
                </p>
              </div>
              <div className={classes.image}>
                <picture>
                  <source srcSet={o3webp} type="image/webp" />
                  <source srcSet={o3} type="image/png" />
                  <img src={o3} alt="Challenge" width={540} />
                </picture>
              </div>
            </li>
            <li className={classes.item}>
              <div className={classes.item__content}>
                <h3>Client & Courier mobile applications</h3>
                <p>
                  End customer interface for making orders. Partner delegates
                  the execution of the order.
                </p>
              </div>
              <div className={classes.image}>
                <picture>
                  <source srcSet={o4webp} type="image/webp" />
                  <source srcSet={o4} type="image/png" />
                  <img src={o4} alt="Challenge" width={540} />
                </picture>
              </div>
            </li>
          </ul>
          <RequestDemo className={`${btnClasses.button} ${classes.button}`} />
        </div>
      </div>
    </section>
  );
}
